export default "__VITE_ASSET__BiyRzJ9z__"